import React from 'react';
import { LiveTranscriptBar } from './LiveTranscriptBar';
import { NewInquiryBar } from './NewInquiryBar';
import { LandmineBar } from './LandmineBar';

// Renders the fixed sub-header row beneath the TopBar:
// Live Transcripts | New Inquiries | Landmines, equal thirds split by hairlines,
// on white with a hairline under the row and no shadow (the macOS strip).
// Each column owns its own `relative` context so each bar's expanded dropdown
// stays within its own column rather than overlapping the other side.
export const CombinedInfoBar: React.FC = () => {
  return (
    <div className="bg-surface border-b border-hairline">
      <div className="flex min-w-0 divide-x divide-hairline">
        <div className="flex-1 min-w-0 relative">
          <LiveTranscriptBar />
        </div>
        <div className="flex-1 min-w-0 relative">
          <NewInquiryBar />
        </div>
        <div className="flex-1 min-w-0 relative">
          <LandmineBar />
        </div>
      </div>
    </div>
  );
};
